<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->
			<el-dialog title="开票失败" :visible.sync="invoiceDialog" width="50%" v-loading='loading' :before-close="close_error_dialog">
							<div
								style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
								<div style="text-align: left;">订单编号:{{fail_order_name}}</div>
								<div style="text-align: left;">错误原因:{{fail_message}}</div>
									<div style="text-align: left;">错误码:{{fail_code}}</div>
								</div>
								<div>
			<div style="text-align: left;">解决办法：</div>
			<div style="text-align: left;">1.电话联系13761553206，并报订单号与错误码</div>
			<div  style="text-align: left;">2. 24小时后到“个人中心->开具发票”页面重新开票</div>
			<div  style="text-align: left;">办公时间：上午8:30-12:00,下午1:30-5:00(节假日及双休日除外)</div>
							</div>
							<span slot="footer" class="dialog-footer">
								<!-- <el-button @click="close_error_dialog">取消</el-button> -->
								<el-button type="danger" @click="close_error_dialog()">关闭</el-button>
							</span>
						</el-dialog>
						
		<el-dialog title="开具发票" :visible.sync="dialogVisible" width="50%" v-loading='loading' :before-close="close_dialog">
			<!-- 	<h3>开票金额</h3>
			<h5 style="color:red">600.00元</h5> -->
			<div
				style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
				<div style="text-align: left;">1. 电子发票与纸质发票具有同等法律效力，提交后30分钟内可开具。</div>
				<div  style="text-align: left;">2. 申请开票后，您可以在开票记录页面自助查询历史开票记录，并下载电子发票。</div>
				

			</div>
				<div style="float: left;font-size: 18px;color:black">开票主体：内蒙古健康教育与健康促进协会，金额 </div>
				<div style="color: red;float: left;font-weight: bold;font-size: 18px;">￥{{total_fees}}</div>
				
				
			<div style="width:100%;border:2px dotted #cdcdcd;padding:20px;overflow: hidden;">
			
				<el-radio-group v-model="account_selected" style="width: 100%;" @change="select_account($event)">
					<el-radio border class="ro-address-radio" v-for="(account_data, index) in account_datas"
						:key="index" :label="account_data.name">
						<span style="width: 100%;" :data-id="account_data.id">{{account_data.unit_name}}</span>
						<div style="width: 100%;" :data-id="account_data.id" class="ro-box-content">
							{{account_data.tax_number}}
						</div>
					</el-radio>
				</el-radio-group>
				<el-row style='text-align: center'>
					<a>
						<el-button style="margin-top: 20px;background: red;color:white;" @click="turn_to_invoice_new">
							新增发票信息
						</el-button>
					</a>
				</el-row>

			</div>
			<el-form>
				<div style="overflow: hidden;margin-top:20px;">
					<!-- <el-form-item label="单位名称" style="float: left;width: 25%;margin-right: 5%">
						<el-input v-model="account_unit_name"></el-input>
					</el-form-item>
					<el-form-item label="纳税人识别号" style=";float: left;width: 25%;;margin-right: 5%">
						<el-input v-model="account_tax_number"></el-input>
					</el-form-item>
					<el-form-item label="发票接收邮箱" style=";float: left;width: 25%;;margin-right: 5%">
						<el-input v-model="account_receive_email"></el-input>
					</el-form-item> -->
					<el-form-item  style=";float: left;margin-right: 5%">
						<div style="float: left;">备注:</div>
						<div style="float: left;margin-left: 10px;"><el-input style="float: left;" type=""  v-model="note"  ></el-input></div>
						
					</el-form-item> 
					<div style="float: left;line-height: 40px;">建议不要超过25个汉字或50个（数字+字母），否则盖章的时候有可能压到。</div>
				</div>
			</el-form>


			<span slot="footer" class="dialog-footer">
				<el-button @click="close_dialog">取消</el-button>
				<el-button type="primary" @click="confirm_create_invoice()">确定</el-button>
			</span>
		</el-dialog>

		<div style="width:100%;background: #F1F1F1;overflow: hidden;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page='selected_page'></rosidebar>
				<div style="float: right;width:calc(100% - 269px);overflow: hidden;height:1090px;background: white;">
					<h4 style="border-bottom: 1px solid #F1F1F1;line-height: 50px;text-align: left;padding-left: 20px;">
						可开具发票订单
					</h4>
					<div style="width: 95%;margin:20px auto;padding:0 10px;border: 2px dotted #F0F0F0;height: 50px;">
						<!-- 	<el-row style="float: left;margin-top: 8px;margin-right: 8px;">
							<el-button size="small">全选</el-button>
							<el-button size="small">反选</el-button>
						</el-row> -->
						<!-- <el-button @click="create_select_invoice" size="small"
							style="float: left;margin-top: 8px;background-color: red;color:white;">
							批量开票</el-button> -->
						<el-pagination style=";margin-top: 8px;float: right;" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-size="PageSize" background
							layout="total, prev, pager, next" :total="totalCount">
						</el-pagination>
					</div>
					<el-table :data="order_datas" style="width: 95%;margin:30px auto;" stripe
					>
					
						<el-table-column prop="code" label="订单编号" width="150">
						</el-table-column>
						<el-table-column prop="type" label="订单类型" width="150">
						</el-table-column>
						<el-table-column prop="name" label="项目名称" width="260">
						</el-table-column>
						<el-table-column prop="unit_name" label="单位名称" width="200">
						</el-table-column>
						<el-table-column prop="create_date" label="创建时间" width="200">
						</el-table-column>
						<el-table-column prop="reporrt_date" label="完成时间" width="200">
						</el-table-column>
						<el-table-column fixed='right' prop="total_fees" label="总金额" width="120">
						</el-table-column>
						<el-table-column fixed='right' label="操作" width="150">
							<template slot-scope="scope">
								<el-button @click="create_invoice(scope.row)" type="success" size="small">开具发票
								</el-button>
							</template>
						</el-table-column>
					</el-table>


				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'user_invoice',
		data() {
			return {
				selected_page: '4-1',
				tabClickIndex: null,
				tabClickLabel: null,
				order_datas: [],
				dialogVisible: false,
				invoiceDialog:false,
								fail_code:'',
								fail_order_name:'',
								fail_message:'',
				account_unit_name: '',
				account_tax_number: '',
				account_receive_email: '',
				account_selected: '',
				loading: false,
				currentPage: 1,
				// 总条数，根据接口获取数据长度(注意：这里不能为空)
				totalCount: 0,
				// 个数选择器（可修改）
				// 默认每页显示的条数（可修改）
				PageSize: 12,
				note:'',
				total_fees:'',
				account_datas:[]

			}
		},
		mounted() {
			var self = this
			var id = this.$route.query.id
			var order_ids = this.$route.query.order_ids
			var total_fees = this.$route.query.total_fees
			// debugger
			if (id != undefined) {
				var row = {'total_fees':total_fees,'id':id}
				this.create_invoice(row)
				// this.get_order_info(id)
			}
			if (order_ids != undefined) {
				
				this.total_fees = total_fees
				// debugger
				this.order_ids = order_ids.split(',')
				this.dialogVisible = true
			}

			this.get_order_data()
			this.get_account_data()
			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {
			handleCurrentChange(val) {
				console.log(val)
				console.log('handleCurrentChange')
				this.currentPage = val
				this.get_order_data()
			},
			
			
			turn_to_invoice_new() {
				// this.order_ids = order_ids
				// this.total_fees = total_fees
				this.$router.push('/user/invoice_new?order_ids='+this.order_ids+'&total_fees='+this.total_fees)
			},
			select_account(e) {

				var id = e
				var select_account_data = this.account_datas.filter(item => item.id == id)[0]
			

			},
			get_invoice_state(){
				var self =this
				var data = {
					'serial_no':this.serial_no
				}
				fetchPost('/ro/connect/get_invoice_state/v1', data).then(response => {
					console.log(response.data)
					if (response.data.state == 'success') {
						
						clearInterval(self.timer)
						self.invoice_done()
				
					}
					if (response.data.state == 'draft') {
						
						console.log('还未回调，继续查询')
									
					}
					if (response.data.state == 'fail') {
						
					
						clearInterval(self.timer)
						self.$message({
							message: '发票申请失败,请重新尝试开票',
							type: 'error'
						});
						self.fail_code = response.data.fail_code
						self.fail_order_name = response.data.fail_order_name
						self.fail_message = response.data.fail_message
						self.dialogVisible = false
						self.loading = false
						self.invoiceDialog = true
						return
						}
				})		
			},
			invoice_done() {
				var self = this
				self.$message({
					message: '发票申请成功,可在开票记录中下载',
					type: 'success'
				});
				self.dialogVisible = false
				self.loading = false
				this.get_order_data()
				window.location.href = '#/user/invoice'
			},
			confirm_create_invoice() {
				if (this.account_selected == '') {
					this.turn_to_invoice_new()
					return
				}
				// debugger
				var data = {
					'account_id': this.account_selected,
					'order_ids': JSON.stringify(this.order_ids),
					'note': this.note,
		
				}
				console.log(data)
				var self = this
				this.loading = true
				fetchPost('/ro/connector/huisuiyun/create_invoice_async/v1', data).then(response => {
					// console.log(response)
					// debugger
					if (response.data.state != 'success') {
						self.$message({
							message: '发票申请失败,请重新尝试开票',
							type: 'error'
						});
						self.fail_code = response.data.fail_code
						self.fail_order_name = response.data.fail_order_name
						self.fail_message = response.data.fail_message
						self.dialogVisible = false
						self.loading = false
						self.invoiceDialog = true
						return
					}
					self.$message({
						message: '发票申请成功,开票完成后可在开票记录中下载',
						type: 'success'
					});
					self.dialogVisible = false
					self.loading = false
					this.get_order_data()
					window.location.href ='#/user/invoice'
			// 		var timer = setInterval(function() {
			// 			console.log('循环查询开票情况')
			// 			self.get_invoice_state()
			
			// 		}, 3000)
			// 		self.timer = timer
			
			// 		self.serial_no = response.data.serial_no
			
			
			
				})
			},
			
			// confirm_create_invoice() {
			// 	if(this.account_selected==''){
			// 		this.turn_to_invoice_new()
			// 		return
			// 	}
			// 	// debugger
			// 	var data = {
			// 		'account_id':this.account_selected,
			// 		'order_ids':JSON.stringify(this.order_ids),
			// 		'note':this.note,
			// 	}
			// 	console.log(data)
			// 	var self = this
			// 	this.loading = true
			// 	fetchPost('/ro/connector/huisuiyun/create_invoice_async/v1', data).then(response => {
			// 		// 	console.log(response)
			// 		if(response.data!='success'){
			// 								self.$message({
			// 									message: '发票申请失败,请重新尝试开票',
			// 									type: 'error'
			// 								});
			// 								self.fail_code = response.data.fail_code
			// 								self.fail_order_name = response.data.fail_order_name
			// 								self.fail_message = response.data.fail_message
			// 								self.dialogVisible = false
			// 								self.loading = false
			// 								self.invoiceDialog = true
			// 								return 
			// 							}
			// 		self.$message({
			// 			message: '发票申请成功,可在开票记录中下载',
			// 			type: 'success'
			// 		});
			// 		self.dialogVisible = false
			// 		self.loading = false
			// 		this.get_order_data()
			// 		window.location.href ='#/user/invoice'
			// 		// location.reload()
			// 		// this.$router.push('/user/invoice')

			// 	})
			// },
			
			get_account_data() {
				// debugger
				var data = {
					id: window.localStorage.getItem('user_id')
				}
				var self = this
				fetchPost('/ro/tec_search/invoice/list/v1', data).then(response => {
					console.log(response)
						debugger
					if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					self.account_datas = response.data.list
					var account_selected = response.data.list.filter(item=>item.default==true)
					if(account_selected.length>0){
						self.account_selected = account_selected[0].id
					}

				})
			},
			get_order_data() {
				var self = this
				// debugger
				var data = {
					'id': window.localStorage.getItem('user_id'),
					'type': 'account',
					'page': this.currentPage,
					'page_size': this.PageSize,
				}
				fetchPost('/ro/tec_search/order/list/v1', data).then(function(response) {
			
					if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					// debugger
					self.order_datas = response.data.list
					self.totalCount = response.data.totalCount
					// debugger
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			create_invoice(row) {
				debugger
				console.log(row);
				this.total_fees = row.total_fees
				var order_ids = []
				order_ids.push(row.id)
				this.order_ids = order_ids
				this.dialogVisible = true
			},
			create_select_invoice() {
				console.log(this.multipleSelection)
				var total_fees = 0
				var order_ids = []
				for(var i=0;i<this.multipleSelection.length;i++){
					console.log(this.multipleSelection[i].total_fees)
					total_fees+=this.multipleSelection[i].total_fees
					order_ids.push(this.multipleSelection[i].id)
				}
				console.log(total_fees)
				console.log(order_ids)
				this.order_ids = order_ids
				this.total_fees = total_fees
				this.dialogVisible = true
			},

			close_dialog(){
				this.dialogVisible = false				
				const targetPath = '/user/invoice';
				if (this.$route.path !== targetPath) {
					this.$router.push(targetPath).catch(err => {
						if (err.name !== 'NavigationDuplicated') {
							// 如果不是重复导航错误，抛出错误
							throw err;
						}
					});
				}
			},
			close_error_dialog(){
				this.invoiceDialog = false
			},
		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}

	.ro-address-radio {
		width: 31%;
		white-space: normal;
		height: 100px !important;
		float: left;
		text-align: left;
		border: 2px solid #cdcdcd !important;
		margin-left: 1% !important;
		margin-right: 1% !important;
	}

	.el-form-item__label {
		color: #333333;
		font-weight: 500;
	}

	.ro-box-content {
		border-top: 2px solid #cdcdcd;
		margin-top: 8px;
		padding-top: 8px;
		line-height: 20px;
	}

	.el-step.is-simple .el-step__icon {
		margin-top: 10px;
	}

	.el-collapse-item__header {
		background-color: #cdcdcd;
		border-radius: 3px;
		height: 35px;
		padding: 0 10px;
		font-weight: 800;
	}

	.el-collapse-item__wrap {
		background-color: #F0F0F0;
		padding: 10px;
		font-weight: 800;
		padding-bottom: 0px !important;
	}

	.el-result {
		padding-top: 0px;
		padding-bottom: 0px;
	}
	.el-dialog__body{
		padding: 0px 20px
	}
</style>
